import React, { useEffect, useState } from "react";
import Button from "../../../components/common/ui/Button";
import {
  DateInput,
  SelectInput,
  TextInput,
} from "../../../components/common/ui/Inputs";
import { useDispatch, useSelector } from "react-redux";
import { inmateAction, masterActions } from "../../../_store";
import { useLocation } from "react-router-dom";
import { fDate, fDate1, MinDate, Today } from "../../../utils/formatTime";
import generateMessagePDF from "../../../components/common/export/Reports/generateMessagePDF";
import generatePhotoPDF from "../../../components/common/export/Reports/generatePhotoPDF";
import JSZip from "jszip";
import CustomLoader from "../../../components/common/ui/Loader";
import { showToastNotification } from "../../../components/common/ui/NotificationModal/ToastNotication";
import loaddataimg from "../../../assets/svg/load-data.svg";

const PostalMail = ({ loadData, render }) => {
  const location = useLocation();
  const { inmate: Inmate } = location.state || {};

  const { PMStatus } = useSelector((x) => x.dropdownOptions);
  const { postalMailRecords, loading, inmate, inmateInfoTabData } = useSelector(
    (x) => x.inmate
  );
  const { loading: masterLoading } = useSelector((x) => x.master);
  const { user, commonFacilityCode } = useSelector((x) => x.auth);

  const [allowDownload, setAllowDownload] = useState(false);
  const [disable, setDisable] = useState(false);
  const [responses, setResponses] = useState([]); // To store all file responses
  const [postalMail, setPostalMail] = useState({
    FacilityID: commonFacilityCode,
    InmateID: Inmate?.InmateID || inmate?.InmateID,
    StartDate: "",
    EndDate: "",
    IsApprove: 3,
  });

  const dispatch = useDispatch();

  useEffect(() => {
    setAllowDownload(loadData);
    setPostalMail({
      FacilityID: commonFacilityCode,
      InmateID: Inmate?.InmateID || inmate?.InmateID,
      StartDate: "",
      EndDate: "",
      IsApprove: 3,
    });
  }, [render]);

  //Bind the Public UserNames for dropdown
  useEffect(() => {
    if (!Inmate?.InmateID && !inmate?.InmateID) return;

    const facilityID =
      Inmate?.facilityID || inmate?.facilityID || commonFacilityCode;
    const inmateID = Inmate?.InmateID || inmate?.InmateID;

    // Dispatch actions for public last name and first name
    dispatch(
      masterActions.GetPublicLastName({
        facilityID,
        firstName: "", // As per the existing logic, leaving firstName as empty string
        inmatesId: inmateID,
      })
    );

    dispatch(
      masterActions.GetPublicFirstName({
        facilityID,
        lastName: "", // As per the existing logic, leaving lastName as empty string
        inmatesId: inmateID,
      })
    );

    setPostalMail({
      ...postalMail,
      FacilityID: facilityID,
      InmateID: inmateID,
    });
  }, [Inmate || inmate]);

  useEffect(() => {
    if (postalMailRecords && postalMailRecords?.length > 0 && allowDownload) {
      setDisable(true);
    } else {
      setDisable(false);
    }
  }, [postalMailRecords, allowDownload]);

  // Fetch data for all postalMailRecords
  useEffect(() => {
    if (postalMailRecords?.length > 0) {
      const downloadAllZipFiles = async () => {
        const fetchedResponses = [];
        const errors = [];

        for (const data of postalMailRecords) {
          const filename = data?.DocumentFileName?.split("/").pop();
          const folderPath = data?.DocumentPath?.split("/")
            .slice(1, -1)
            .join("/");

          try {
            const response = await dispatch(
              masterActions.DownLoadZipFiles({ filename, folderPath })
            ).unwrap(); // Wait for each dispatch to complete
            fetchedResponses.push({ filename, blob: response });
          } catch (error) {
            // errors.push(filename); // Track failed downloads
          }
        }

        // Ensure state update always happens, even if errors occur
        if (fetchedResponses.length > 0) {
          setResponses(fetchedResponses); // Store all successful responses
          // setAllowDownload(true); // Enable the download button
        } else {
          setResponses([]); // Reset state if no files were fetched
          // setAllowDownload(false); // Disable download button
        }

        if (errors.length > 0) {
        }
      };

      downloadAllZipFiles();
    }
  }, [postalMailRecords, dispatch]);

  // Handle ZIP download
  const handleDownload = async (e) => {
    e.preventDefault();
    if (responses.length > 0) {
      createSingleZip(responses); // Create and download the zip file
      setDisable(false);
      setAllowDownload(false);
      dispatch(inmateAction.clearPostalMail());
      setResponses([]);
    } else {
      showToastNotification("No files to download", "error");
    }
  };

  // Create ZIP file from responses
  const createSingleZip = async (responses) => {
    try {
      const zip = new JSZip();

      // Add each file to the ZIP
      responses.forEach(({ filename, blob }) => {
        zip.file(filename, blob); // Add the file to the zip
      });

      // Generate the ZIP file as a Blob
      const zipBlob = await zip.generateAsync({ type: "blob" });

      // Get the current date in YYYY-MMM-DD format
      const currentDate = new Date();
      const formattedDate = fDate1(currentDate);

      const fileName = Inmate
        ? `${Inmate?.LastName}_${Inmate?.FirstName}_${formattedDate}.zip`
        : `${inmate?.LastName}_${inmate?.FirstName}_${formattedDate}.zip`;
      // Trigger download
      const url = window.URL.createObjectURL(zipBlob);
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      showToastNotification("Error generating ZIP file:", "error");
    }
  };

  // const FacilityName = facilityDropDown?.find(
  // (item) => item?.value === parseInt(commonFacilityCode)
  // )?.label;

  let updatedSearch = { ...postalMail };

  const handleSelectChange = (selectedOption, name) => {
    updatedSearch[name] = selectedOption !== null ? selectedOption?.value : 3;
    // LoadPUGridList();

    setPostalMail(updatedSearch);
  };

  const handleDateChange = (value, name) => {
    const date = fDate(value);
    updatedSearch[name] = date;

    setPostalMail(updatedSearch);
  };

  const handleDateEnterKey = (event, name) => {
    if (event.key === "Enter" && updatedSearch[name] === "") {
      const currentDate = new Date();

      // Set today's date using the same logic as your handleDateChange
      handleDateChange(currentDate, name);
    }

    const regex = /^[0-9/]$/; // Allow numbers and "/"

    if (
      !regex.test(event.key) &&
      event.key !== "Backspace" &&
      event.key !== "Delete" &&
      !(event.ctrlKey && event.key === "v")
    ) {
      event.preventDefault();
    }

    // Auto-insert '/' when typing
    const input = event.target.value;

    if (event.key !== "Backspace" && event.key !== "Delete") {
      if (input?.length === 2 || input?.length === 5) {
        event.target.value = input + "/";
      }
    }
  };

  const handleDateBlur = (e, fieldName) => {
    let { value } = e.target;
    let isFromValid = true;
    let isToValid = true;

    if (fieldName === "StartDate") {
      if (
        updatedSearch.EndDate &&
        new Date(value) > new Date(updatedSearch.EndDate)
      ) {
        // Invalid: FromDate cannot be after ToDate
        isFromValid = false;
      }
    } else if (fieldName === "EndDate") {
      if (
        updatedSearch.StartDate &&
        new Date(value) < new Date(updatedSearch.StartDate)
      ) {
        // Invalid: ToDate cannot be before FromDate
        isToValid = false;
      }
    }

    // Define date format used
    const minDate = MinDate();
    const today = Today();
    const valueDate = new Date(value);
    const isValidDate = valueDate >= minDate && valueDate <= today;

    let updatedParam = {
      ...updatedSearch,
      StartDate:
        fieldName === "StartDate"
          ? isFromValid && isValidDate
            ? value
            : ""
          : updatedSearch.StartDate, // preserve existing value
      EndDate:
        fieldName === "EndDate"
          ? isToValid && isValidDate
            ? value
            : ""
          : updatedSearch.EndDate, // preserve existing value
    };
    setPostalMail(updatedParam);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    dispatch(inmateAction.LoadPostalMailSearch(postalMail));

    setAllowDownload(true);
  };

  const handleCancel = (e) => {
    e.preventDefault();
    setDisable(false);
    setAllowDownload(false);
    dispatch(inmateAction.clearPostalMail());
    setResponses([]);
  };

  if (loading || masterLoading) {
    return <CustomLoader />;
  }

  return (
    <>
      <div className="p-2 ">
        <h4 className="inner-header-bg text-color">
          {" "}
          <i className="fa-solid fa-filter me-2"></i>Filter{" "}
        </h4>
        <form onSubmit={(e) => handleSubmit(e)}>
          <div className="row">
            <div className="p-2 m-1 d-flex flex-wrap align-items-center">
              <div className="col-sm-12 col-md-4 me-1 ">
                <label className="fs-5">Inmate Last Name :</label>
                <strong className="fs-5 text-end mx-2">
                  {Inmate?.LastName ||
                    inmate?.LastName ||
                    (inmateInfoTabData?.length > 0 &&
                      inmateInfoTabData[0]?.LastName)}
                </strong>
              </div>

              <div className="col-sm-12 col-md-4 ">
                <label className="fs-5">Inmate First Name :</label>
                <strong className="fs-5 text-end mx-2">
                  {Inmate?.FirstName ||
                    inmate?.FirstName ||
                    (inmateInfoTabData?.length > 0 &&
                      inmateInfoTabData[0]?.FirstName)}
                </strong>
              </div>
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-sm-6 col-md-4">
              <div className="form-floating mb-3">
                <DateInput
                  value={postalMail?.StartDate}
                  handleChange={(e) => handleDateChange(e, "StartDate")}
                  name="StartDate"
                  label={"From Date"}
                  maxDate={
                    postalMail?.EndDate ? postalMail?.EndDate : new Date()
                  }
                  required={false}
                  disabled={disable}
                  yearDropDown={false}
                  monthDropDown={false}
                  className={false ? "disabled-date-input" : ""} // Add class conditionally
                  isClearable={postalMail?.StartDate}
                  preventClear={!postalMail?.StartDate}
                  minDate={new Date(2017, 0, 1)}
                  handleBlur={(e) => handleDateBlur(e, "StartDate")}
                  handleKeyDown={(e) => handleDateEnterKey(e, "StartDate")}
                ></DateInput>
              </div>
            </div>

            <div className="col-sm-6 col-md-4">
              <div className="form-floating mb-3">
                <DateInput
                  value={postalMail?.EndDate}
                  handleChange={(e) => handleDateChange(e, "EndDate")}
                  name="EndDate"
                  minDate={
                    postalMail?.StartDate
                      ? postalMail?.StartDate
                      : new Date(2017, 0, 1)
                  }
                  label={"To Date"}
                  maxDate={new Date()}
                  required={false}
                  disabled={disable}
                  yearDropDown={false}
                  monthDropDown={false}
                  isClearable={postalMail?.EndDate}
                  preventClear={!postalMail?.EndDate}
                  handleBlur={(e) => handleDateBlur(e, "EndDate")}
                  handleKeyDown={(e) => handleDateEnterKey(e, "EndDate")}
                ></DateInput>
              </div>
            </div>

            <div className="col-sm-6 col-md-4">
              <div className="form-floating mb-3">
                <SelectInput
                  options={PMStatus}
                  value={postalMail?.IsApprove}
                  handleChange={(e) => handleSelectChange(e, "IsApprove")}
                  name="IsApprove"
                  label={"Status"}
                  required={false}
                  isDisabled={disable}
                  isClearable={postalMail?.IsApprove !== 3}
                ></SelectInput>
              </div>
            </div>
            {/* Fourth Row: Connection, Status */}
          </div>

          <div className="mt-3 d-flex flex-wrap flex-wrap  gap-3">
            {postalMailRecords &&
              postalMailRecords?.length > 0 &&
              allowDownload && (
                <div className="d-flex flex-wrap  flex-wrap align-items-start">
                  <label className="fs-5 fw-bold" style={{ color: "#009759" }}>
                    Data loaded successfully. Click download button to export
                    PDF.
                  </label>
                </div>
              )}

            {postalMailRecords &&
              postalMailRecords?.length === 0 &&
              allowDownload && (
                <div className="d-flex flex-wrap flex-wrap align-items-start">
                  <label className="fs-5 fw-bold text-danger">
                    No Data Available
                  </label>
                </div>
              )}

            <div className="d-flex flex-wrap flex-wrap ms-auto">
              {postalMailRecords?.length === 0 && (
                <Button
                  className="me-2"
                  label={"LOAD DATA"}
                  type={"submit"}
                  imgsrc={loaddataimg}
                  status={"btn-label"}
                  disabled={false}
                ></Button>
              )}
              {postalMailRecords?.length > 0 && allowDownload && (
                <>
                  <Button
                    className="me-2"
                    label={"CANCEL"}
                    type={"submit"}
                    variant="danger"
                    status={"primary"}
                    icon={"fa-solid fa-xmark"}
                    disabled={false}
                    onClick={handleCancel}
                  />
                  <Button
                    className="me-2"
                    label={"Download"}
                    icon={"fa-solid fa-download"}
                    type={"button"}
                    status={"success"}
                    disabled={false}
                    onClick={(e) => handleDownload(e)}
                  ></Button>
                </>
              )}
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default React.memo(PostalMail);
